export default function mergeProducts(defaultProduct, productFromGA) {
  return {
    ...productFromGA,
    id: defaultProduct.id,
    link: defaultProduct.link,
    brand_link: defaultProduct.brand_link,
    hasFavourite: defaultProduct.hasFavourite,
    sku: defaultProduct.sku,
    description: defaultProduct.description,
    beauty_procedure_id: defaultProduct.beauty_procedure_id,
    beauty_routine_id: defaultProduct.beauty_routine_id,
    quiz_quest_id: defaultProduct.quiz_quest_id,
    group: defaultProduct.group,
  };
}
